/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { InventoryRecordItemDto } from './InventoryRecordItemDto';
export type UpdateInventoryRecordWithItemsDto = {
  /**
   * Destination location ID
   */
  destinationLocationId: number;
  /**
   * Record-level supplier (omit to leave unchanged)
   */
  supplierId?: number;
  /**
   * Record status
   */
  status: UpdateInventoryRecordWithItemsDto.status;
  /**
   * Items in the inventory record - can include new items, updated items, or items to delete
   */
  items: Array<InventoryRecordItemDto>;
};
export namespace UpdateInventoryRecordWithItemsDto {
  /**
   * Record status
   */
  export enum status {
    COMPLETED = 'COMPLETED',
    CANCELLED = 'CANCELLED',
    PENDING = 'PENDING',
  }
}
